<div class="col-md-12 noBottomMargin noPaddingMd-12 borderDiv" >
  <div class="col-md-12 contactBreadCrumbDiv">
    <ol class="breadcrumb">
      <li><a href="">{{'global.menu.home' | translate}}</a></li>
      <li><a href="">{{'global.menu.accountt' | translate}}</a></li>
      <li class="active">{{'global.menu.activateaccount' | translate}}</li>
    </ol>
  </div>
  <div class="col-md-12">
    <h2 class="changePasswordHeading">{{'global.menu.activateaccount' | translate}}</h2>
  </div>
  <div class="col-md-12 mainPasswordDiv">
    <div class="alert alert-danger centerText" *ngIf="erroract" >
      <strong>{{'error.accounterror' | translate}}</strong>
    </div>

    <div class="alert alert-danger centerText" *ngIf="initerror">
      <strong>{{'error.accountiniterror' | translate}}</strong>
    </div>

    <div class="alert alert-danger centerText" *ngIf="error001" >
      <strong>{{'error.accounterror.001' | translate}}</strong>
    </div>

    <div class="alert alert-danger centerText" *ngIf="error002" >
      <strong>{{'error.accounterror.002' | translate}}</strong>
    </div>

    <div class="alert alert-danger centerText" *ngIf="error003" >
      <strong>{{'error.accounterror.003' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="error004">
      <strong>{{'error.accounterror.004' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="error005">
      <strong>{{'error.accounterror.005' | translate}}</strong>
    </div>
    <div class="alert alert-danger centerText" *ngIf="error007" >
      <strong>{{'error.accounterror.007' | translate}}</strong>
    </div>
    <!-- Disable password history validation messsages -->
    <!--
    <div class="alert alert-danger centerText" *ngIf="error008" >
      <strong>{{'error.accounterror.008' | translate}}</strong>
    </div>
    -->

    <div class="alert alert-danger centerText" *ngIf="doNotMatch">
      <strong>{{'password.messages.dontmatch' | translate}}</strong>
    </div>
    <form #passwordForm="ngForm" name="form"  (submit)="activateAccount()"   *ngIf="successact">
      <div class="col-md-3 noPaddingMd-12">
        <div class="login-form-group pmi_form_group">
          <input type="text"  id="certificatenumber" name="certificatenumber" [(ngModel)]="certificatenumberVal"
                 autocomplete="off" autofocus required>
          <span class="bar"></span>
          <label>{{'global.form.certificatenumber' | translate}}</label>
        </div>
      </div>
      <div class="col-md-3 noPaddingMd-12">
        <div class="login-form-group pmi_form_group">
          <input type="text" name="dateOfBirthText" [textMask]="{mask: mask ,guide:true ,keepCharPositions:true}" (keyup)="updateDatePicker()" [(ngModel)]="dateOfBirthText" autofocus required>
          <span class="bar"></span>
          <label>{{'global.form.dateofbirth' | translate}}</label>
          <my-date-picker  name="mydate"
                           [options]="myDatePickerOptions" (dateChanged)="onDateChanged($event)"
                           required [(ngModel)]="dateOfBirth" required></my-date-picker>
        </div>
      </div>
      <div class="col-md-3 noPaddingMd-12">
        <div class="login-form-group pmi_form_group">
          <input type="password"  id="password" name="password" [(ngModel)]="passwordval"
                 pattern="^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$" (change)="updateLabelStyle()"
                 minlength=4 maxlength=20 required #password="ngModel"   autocomplete="off" autofocus required>

          <span class="bar"></span>
          <label [ngClass]="[updateStyle ? 'customLabel' : '']">{{'global.form.newpassword' | translate}}</label>
          <p></p>
        </div>
      </div>
      <div class="col-md-3 noPaddingMd-12">
        <div class="login-form-group pmi_form_group">
          <input type="password"  id="confirmPassword"
                 name="confirmPassword" [(ngModel)]="confirmPasswordVal" (change)="updateLabelConfirmPasswordlabel()"
                 pattern="^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"
                 minlength=4 maxlength=20 #confirmPassword="ngModel"  autocomplete="off" autofocus required>
          <span class="bar"></span>
          <label [ngClass]="[updateLabel ? 'customLabel' : '']">{{'global.form.confirmpassword' | translate}}</label>

          <!--
                        <span class="highlight"></span>
          -->

        </div>
      </div>
      <div class="col-md-12">
        <div class="col-md-3 noPaddingMd-12">
          <div class="login-form-group pmi_form_group">
            <input type="text"  id="emailId" name="emailId" [(ngModel)]="emailIdVal"
                   #emailId="ngModel" maxlength="600" (ngModelChange)="updateEmailIdLabelAndValidate()" autocomplete="off" autofocus required>
            <span class="bar"></span>
            <label [ngClass]="[updateEmailLabel ? 'customLabel' : '']">Email</label>
            <p></p>
            <div *ngIf="invalidEmail">
              <p class="emailError">{{'global.messages.validate.email.invalid' | translate }}</p>
            </div>
            <div>
              <p class="passwordHint"><i>*&nbsp;{{'global.messages.validate.email.hint' | translate }}</i></p>
            </div>
          </div>

        </div>
        <div class="col-md-3 noPaddingMd-12">
          &nbsp;
        </div>
        <div class="col-md-3 noPaddingMd-12">
          <div *ngIf="password.errors && (password.dirty || password.touched)">
            <p class="passwordError" *ngIf="password.errors.pattern">{{'global.form.passwordvalidation' | translate}}</p>
          </div>
        </div>
        <div class="col-md-3 noPaddingMd-12">
          <div *ngIf="confirmPassword.errors && (confirmPassword.dirty || confirmPassword.touched)">
            <p class="passwordError" *ngIf="confirmPassword.errors.pattern">{{'global.form.passwordvalidation' | translate}}</p>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="col-md-4 noPaddingMd-12">
          &nbsp;
        </div>
        <div class="col-md-4 btnDiv">
          <button type="submit"  class="btn btn-primary passBtn" [disabled]="!passwordForm.form.valid">{{'password.form.button' | translate}}</button>
        </div>
        <div class="col-md-4 noPaddingMd-12">
          &nbsp;
        </div>
      </div>

    </form>
  </div>
</div>
